// extracted by mini-css-extract-plugin
export default {"wrap":"Tutorial_wrap__FfI2o","fixWindow":"Tutorial_fixWindow__Zj4NI"};